import { render } from "./AddExercise.vue?vue&type=template&id=7903ab7a"
import script from "./AddExercise.vue?vue&type=script&lang=js"
export * from "./AddExercise.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__